import dayjs from "@helpers/dayjs"

/* 0 is Monday,6 is Sunday */
export enum DaysOfTheWeek {
  Monday = 0,
  Tuesday = 1,
  Wednesday = 2,
  Thursday = 3,
  Friday = 4,
  Saturday = 5,
  Sunday = 6,
}

export class MenuHours {
  constructor(
    public dayOffset: DaysOfTheWeek,
    public openTimeHour: number,
    public openTimeMinute: number,
    public closeTimeHour: number,
    public closeTimeMinute: number,
  ) {}

  containsTime(time: dayjs.Dayjs): boolean {
    const openTime = time
      .clone()
      .set("hour", this.openTimeHour)
      .set("minute", this.openTimeMinute)
      .add(this.dayOffset, "day")
    let closeTime = time
      .clone()
      .set("hour", this.closeTimeHour)
      .set("minute", this.closeTimeMinute)
      .add(this.dayOffset, "day")
    if (openTime.hour() > closeTime.hour()) {
      closeTime = closeTime.add(1, "day")
    }
    // Check if the time is within bounds if offset by one week as well.
    // This is necessary because if hours wrap around past midnight, we may
    // be doing some weird stuff with day offsets.
    const timeOneWeekLater = time.clone().add(1, "week")
    return (
      (time.isAfter(openTime) && time.isBefore(closeTime)) ||
      (timeOneWeekLater.isAfter(openTime) &&
        timeOneWeekLater.isBefore(closeTime))
    )
  }

  static fromDynamic(data: { [key: string]: any }): MenuHours {
    return new MenuHours(
      data["day_offset"],
      data["open_time"]["hour"],
      data["open_time"]["minute"],
      data["close_time"]["hour"],
      data["close_time"]["minute"],
    )
  }
}
